export const participantContent={
    EXISTING_PARTICIPANT_ERROR: "Participant Already exists",
    SELF_USER_ERROR: "Can not add your own email"
}